function defaultDashboardId(dashboards) {
  const defaultDashboard = dashboards.find(dashboard => dashboard.isDefaultScreen === true);

  if (defaultDashboard) {
    const { id } = defaultDashboard;
    return id;
  }

  const firstDashboard = dashboards.find(dashboard => dashboard.ordinal === 1);
  if (!firstDashboard) {
    return null;
  }
  const { id } = firstDashboard;
  return id;
}

function updateDashboardListItems(data, dashboardList) {
  const { currentDashboardId, deepCopyDashboardId } = data;

  const originalCannedDashboardIndex = dashboardList.findIndex(
    dashboard => dashboard.id === currentDashboardId
  );

  const originalCannedDashboard = dashboardList.find(
    dashboard => dashboard.id === currentDashboardId
  );

  const updatedCannedDashboard = { ...originalCannedDashboard, id: deepCopyDashboardId };

  dashboardList.splice(originalCannedDashboardIndex, 1, updatedCannedDashboard);

  if (originalCannedDashboard.isDefaultScreen === true) {
    return { dashboardList, defaultDashboardId: deepCopyDashboardId };
  }

  return dashboardList;
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'DASHBOARD_LIST_READY':
      return {
        dashboardsList: action.payload.dashboards,
        defaultDashboardId: defaultDashboardId(action.payload.dashboards),
        masterObjectName: action.payload.masterObjectName,
        isDefaultTemplate: action.payload.areDefault
      };
    case 'DASHBOARD_UPDATE_LIST_ITEM':
      return {
        ...state,
        isDefaultTemplate: false,
        ...updateDashboardListItems(action.payload, state.dashboardsList)
      };
    case 'SET_IS_EMPTY_LIST':
      return {
        ...state,
        isEmptyList: action.payload
      };

    // TODO: Case for zero dashboards

    default:
      return state;
  }
};

export const initialState = {
  dashboardsList: [],
  defaultDashboardId: null,
  isDefaultTemplate: true,
  masterObjectName: null,
  isEmptyList: null
};
